module.exports = __webpack_public_path__ + "img/05.a0ed104c.png";